import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-expand-panel',
    templateUrl: './expand-panel.component.html',
    styleUrls: ['./expand-panel.component.css'],
    standalone: false
})
export class ExpandPanelComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string = null;

  @Input() @HostBinding('class.collapsible') collapsible: boolean;

  @HostBinding('class.collapsed')
  collapsed = false;

  constructor() {
  }

  ngOnInit() {
  }

  toggleExpand() {
    if (this.collapsible) {
      this.collapsed = !this.collapsed;
    }
  }

  getIcon() {
    return this.collapsed ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
  }
}
